import React from 'react';

import {
  CheckboxCheckedIcon,
  CheckboxIndeterminateIcon,
  CheckboxUncheckedIcon,
} from '@/shared/assets/icons/checkbox-icon';
import { StyledCheckbox } from '@/shared/components/ui/checkbox/checkbox.styled';
import { TCheckboxProps } from '@/shared/components/ui/checkbox/checkbox.types';

export const Checkbox: React.FC<TCheckboxProps> = ({ size, ...props }) => {
  return (
    <StyledCheckbox
      {...props}
      $size={size}
      icon={<CheckboxUncheckedIcon />}
      checkedIcon={<CheckboxCheckedIcon />}
      indeterminateIcon={<CheckboxIndeterminateIcon />}
    />
  );
};
